import { ref } from 'vue';

const toasts = ref([]);
let nextId = 0;

export function useToast() {
  function addToast(message, variant = 'success', duration = 4000) {
    const id = nextId++;
    toasts.value.push({ id, message, variant });
    setTimeout(() => {
      toasts.value = toasts.value.filter((t) => t.id !== id);
    }, duration);
  }

  function success(message) {
    addToast(message, 'success');
  }

  function error(message) {
    addToast(message, 'danger');
  }

  return { toasts, success, error };
}
